import config from '../../../config'
import { setToken, genericHandleApiError, requestOk } from './api-util'
import { fetchWithTimeout } from '../util/fetch'

import 'formdata-polyfill'

class UserUploadServiceApi {
  static batchImportUsers = (file, token) => {
    const myHeaders = new Headers()
    setToken(myHeaders, token)
    myHeaders.append('Accept', 'application/json')

    const formData = new FormData()
    formData.append('file', file[0])

    const myInit = {
      method: 'POST',
      headers: myHeaders,
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      body: formData,
    }

    return fetchWithTimeout(
      `${config.userUploadServiceUrl}/users/upload`,
      myInit,
      config.requestTimeoutBatchImport,
      'Timeout',
    ).then(response => {
      if (requestOk(response)) {
        return response.json()
      }
      return genericHandleApiError(response)
    })
  }
}

export default UserUploadServiceApi
